import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/style.less'
import '@/styles/theme-control.less'
import '@/styles/theme-control.css'
import '@/styles/txt.wav.css'
import '@/icons/iconfont.js'
import '@/utils/utils.js'

import 'font-awesome/css/font-awesome.min.css'


Vue.use(ElementUI,{size: 'small'});
Vue.prototype.$axios = axios;

Vue.config.productionTip = false


new Vue({
    router,
    store,
    created(){
        //路由拦截
        this.$store.commit('menu/setToken', localStorage.getItem('token'));
        router.beforeEach((to, from, next) => {
            if(to.path == '/'){
                next();
            }else{
                const token = this.$store.state.menu.token;
                if(token == null || token === ''){
                    next('/')
                }else{
                    next();
                }
            }
        })
    },
    render: h => h(App)
}).$mount('#app')
